import { z } from 'zod';

export const COMPLETION_NOTE_MAX_LENGTH = 1000;

export const completeCancellationSchema = z.object({
    note: z
        .string()
        .trim()
        .min(1, 'Enter a note explaining why this is being completed')
        .max(COMPLETION_NOTE_MAX_LENGTH, `The note cannot exceed ${COMPLETION_NOTE_MAX_LENGTH} characters`),
});

export type CompleteCancellationFormInput = z.input<typeof completeCancellationSchema>;
export type CompleteCancellationValues = z.output<typeof completeCancellationSchema>;
